import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export default function Nav() {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `text-sm font-medium tracking-wide transition-colors ${
      isActive ? 'text-amber-600' : 'text-charcoal hover:text-amber-600'
    }`;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-warm-border">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <img
              src="/jambitionlogo.png"
              alt="Jambition"
              className="h-9 w-auto"
            />
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-10">
            <NavLink to="/services" className={linkClass}>
              Services
            </NavLink>
            <NavLink to="/about" className={linkClass}>
              About
            </NavLink>
            <Link
              to="/audit"
              className="bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold px-5 py-2.5 transition-colors"
            >
              Get Free Audit
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden text-charcoal p-1"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-white border-t border-warm-border px-6 py-5 flex flex-col gap-5">
          <NavLink
            to="/services"
            className="text-base font-medium text-charcoal hover:text-amber-600 transition-colors"
            onClick={() => setOpen(false)}
          >
            Services
          </NavLink>
          <NavLink
            to="/about"
            className="text-base font-medium text-charcoal hover:text-amber-600 transition-colors"
            onClick={() => setOpen(false)}
          >
            About
          </NavLink>
          <Link
            to="/audit"
            className="bg-amber-600 text-white text-center text-base font-semibold px-5 py-3 transition-colors"
            onClick={() => setOpen(false)}
          >
            Get Free Audit
          </Link>
        </div>
      )}
    </nav>
  );
}
